import React, { useEffect, useMemo, useState } from "react";
import { MoneyExUsers } from "../../../pages";
import { MoneyExController } from "../../../controllers";

const MoneyExUsersContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  const moneyExUsersTableQuery = useMemo(() => {
    const query = `offset=${currentPage + 1}&limit=${limit}`;
    return query;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = MoneyExController.useGetMoneyExUsers(
    moneyExUsersTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const closeModal = () => {
    setMoreInfoModal(false);
  };

  return (
    <MoneyExUsers
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      moreInfoModal={moreInfoModal}
      setMoreInfoModal={setMoreInfoModal}
      closeModal={closeModal}
    />
  );
};

export default MoneyExUsersContainer;
